import React from 'react';
import { useInView } from 'react-intersection-observer';

/**
 * The one motion flourish the handoff allows: a 16px fade-and-rise on
 * section entry, once. Skipped for the hero so the first paint is instant.
 * `prefers-reduced-motion` is handled in CSS (.reveal is forced visible).
 */
const Reveal = ({ children, className = '' }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.08 });

  return (
    <div ref={ref} className={`reveal ${inView ? 'revealed' : ''} ${className}`.trim()}>
      {children}
    </div>
  );
};

export default Reveal;
